<template>
  <div class="body">
    <div class="header">
      <img src="@/assets/image/logo.svg" alt="logo" />
      <span>已登录</span>
    </div>
    <div class="main">
      <div class="main_warp">
        <div class="title">
          <h2>{{ data.title }}</h2>
          <li>
            <span
              >发布时间：{{
                $utils.formatDate(data.publishTime, "yyyy-MM-dd")
              }}</span
            >
            <span>来源：{{ data.source }}</span>
            <span>举报</span>
          </li>
        </div>
        <div class="new-content">
          <p v-html="data.content"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },

  mounted() {
    const data = this.$store.getters["news/getData"];
    this.data = data;
  },
};
</script>

<style lang="scss" scoped>
.body {
  min-height: 100%;
  background-color: #f6f6f8;
}
.header {
  height: 80px;
  display: flex;
  padding: 0 24px;
  margin-bottom: 24px;
  align-items: center;
  background-color: #ffffff;

  img {
    height: 50px;
  }

  span {
    margin-left: auto;
    font-size: 0.875rem;
    color: $--color-text-regular;
  }
}

.main_warp {
  width: 880px;
  margin: 0 auto;
  padding-bottom: 50px;

  .title {
    border-bottom: 1px solid #c5c5c5;
    h2 {
      font-weight: 500;
      line-height: 36px;
      font-size: 1.875rem;
    }
    li {
      display: flex;
      font-size: 0.875rem;
      padding: 24px 0 16px 0;
      color: $--color-text-regular;

      span {
        &:nth-child(2) {
          margin-left: 15px;
        }
        &:last-child {
          cursor: pointer;
          margin-left: auto;
          color: $--color-danger;
        }
      }
    }
  }
  .new-content {
    padding-top: 24px;
    font-size: 0.875rem;
    line-height: 24px;
    color: $--color-text-regular;
  }
}
</style>